// Shared admin-verification helpers used by the list view, the detail view,
// edit mode, and the running-verification panel. Keeping the status sets
// and the Betterstack log builder in one place prevents the row-click
// behavior and "View details" button (and the two Force-match dialogs)
// from drifting out of sync.

// Lowercase, used by the verifications list (`status` values come back from
// the list endpoint in lowercase).
export const ADMIN_OPENABLE_STATUSES = new Set([
  'ready_for_review',
  'created',
  'pending',
  'running',
  'failed',
  'no_match',
]);

export const isRowClickable = (status, isAdmin) => {
  const s = (status || '').toLowerCase();
  if (s === 'completed') return true;
  return isAdmin && ADMIN_OPENABLE_STATUSES.has(s);
};

// Uppercase, used by the detail view (`_status` is uppercased before it
// reaches EditModeContext).
//
// EDIT_MODE_STATUSES gates the Edit button + action bar — broad so admins
// keep access during reprocess.
//
// DATA_EDITABLE_STATUSES gates inline editors + SaveBar — narrow to what
// the backend's PATCH /detail-data endpoint actually accepts.
export const EDIT_MODE_STATUSES = new Set([
  'CREATED',
  'PENDING',
  'RUNNING',
  'READY_FOR_REVIEW',
  'COMPLETED',
  'NO_MATCH',
  'FAILED',
]);

export const DATA_EDITABLE_STATUSES = new Set(['READY_FOR_REVIEW', 'COMPLETED']);

const BETTERSTACK_SOURCES = {
  production: '1293795',
  staging: '1293744',
};

export const getLogsUrl = (verificationId) => {
  const host = window.location.hostname;
  const source =
    host.includes('staging') || host.includes('localhost') || host.includes('127.0.0.1')
      ? BETTERSTACK_SOURCES.staging
      : BETTERSTACK_SOURCES.production;
  const base = `https://telemetry.betterstack.com/team/t323294/tail?s=${source}&q=`;
  return `${base}${encodeURIComponent(`verification_id='${verificationId}'`)}`;
};
